<button *ngIf="type === 'button'"   [type]="type" pButton [label]="text" [icon]="icon" (click)="handleClick($event)"  style="margin-left:.25em"></button>
<p-button *ngIf="type === 'outline'"n styleClass="p-button-outlined" (click)="handleClick($event)">
    <img alt="logo" src="assets/images/Google.png" style="width: 1.5rem; margin-right: 5px"/>
    <span class="ml-2 font-bold">Google</span>
</p-button>